import { render, staticRenderFns } from "./header_menu.vue?vue&type=template&id=4f8098f0&"
import script from "./header_menu.vue?vue&type=script&lang=js&"
export * from "./header_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrazeWrapper: require('/var/web/bet777.es/components/braze-wrapper.vue').default})
